import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=764b1f2a"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"
import style0 from "./MainBanner.vue?vue&type=style&index=0&id=764b1f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports